import apiService from "./apiService";

const NotificationPhoneService = {

    postSendNotification: (data) => apiService.post(`/api/v1/notifications_phone/send_notification`, data),

    //   getUserById: (id) => apiService.get(`/users/${id}`),
    //   createUser: (userData) => apiService.post("/users", userData),
    //   updateUser: (id, userData) => apiService.put(`/users/${id}`, userData),
    //   deleteUser: (id) => apiService.delete(`/users/${id}`),
};

export default NotificationPhoneService;
